const  CompanyApprovalReducer = (state = { loader: false, result: [], error: null }, action) => {
    switch (action.type) {
      case 'APPROVAL_REQUEST_LIST_BEGINS':
        return {
          loader: true,
          result: {},
          error: null,
        };
      case 'APPROVAL_REQUEST_LIST_SUCCESS':
        return {
          loader: false,
          result: action.payload,
          error: null,
        };
      case 'APPROVAL_REQUEST_LIST_FAILURE':
        return {
          loader: false,
          result: {},
          error: action.payload,
        };
      case 'APPROVAL_REQUEST_LIST_RESET':
        return {
          loader: false,
          result: {},
          error: null,
        };
        case 'TOOGLE_LOADER':
        return {
          loader: action.payload,
        };
      default:
        return state;
    }
  };
  

  export default CompanyApprovalReducer;